import SwitchAccountForm from './SwitchAccountForm'
export default SwitchAccountForm
